module.exports = __webpack_public_path__ + "static/media/cover.64009494.png";